import {defineStore} from 'pinia'

export const mainTypes = [
    {id: 'cpa', name: 'CPA'},
    {id: 'rs', name: 'RevShare'},
    {id: 'hybrid', name: 'Hybrid'}
]

export const mainStore = defineStore('main', {
    state: () => ({
        versionDisplay: '',
        widthDisplay: null,
        typeProfile: [],
        translations: {},
        globalLoading: false,
        globalView: false,
        infoProfile: {},
        isSafari: /^((?!chrome|android).)*safari/i.test(navigator.userAgent),
        isClickIdEnabled: false,
        isClickIdFetch: false
    }),
    getters: {},
    actions: {
        setVersionDisplay(data) {
            this.widthDisplay = data
            if (data > 1365) {
                this.versionDisplay = false
            } else this.versionDisplay = true
        },

        setType(data) {
            if (data && !data.length) {
                this.typeProfile = []

                return
            }
            let types = []
            for (let type of data) {
                const findType = mainTypes.find(t => type.includes(t.id))
                if (findType) types.push(findType)
            }

            this.typeProfile =  types.sort((a, b) =>
                mainTypes.findIndex(x => x.id === a.id) - mainTypes.findIndex(x => x.id === b.id)
            );
        },
        setTranslation(locale, array) {
            this.translations[locale] = array
        },
        setGlobalLoading(value) {
            this.globalLoading = value
        },
        setGlobalView(value) {
            this.globalView = value
        },
        setInfoProfile(data) {
            this.infoProfile = data
        },
        clearType() {
            this.globalView = false
            this.typeProfile = []
        },
        setClickIdEnabled(value) {
            this.isClickIdEnabled = value
            this.isClickIdFetch = true
        },
    },
})
